import { createContext, useContext } from 'react';
import type { FooterView } from './AppsFooter.constants';

export interface AppsFooterContextValue {
  readonly open: boolean;
  readonly expanded: boolean;
  readonly view: FooterView;
  readonly setOpen: (open: boolean) => void;
  readonly setExpanded: (expanded: boolean) => void;
  readonly setView: (view: FooterView) => void;
  readonly showMarketplace: () => void;
}

export const AppsFooterContext = createContext<AppsFooterContextValue | undefined>(undefined);

export const useAppsFooter = (): AppsFooterContextValue => {
  const ctx = useContext(AppsFooterContext);
  if (!ctx) throw new Error('useAppsFooter must be used within AppsFooterProvider');
  return ctx;
};
